import { authService } from "../../utils/authService";
import { errorHandler } from "../../components/shared/errorhandler";

interface InstanceFormData {
  id?: string;
  [key: string]: unknown;
}

interface InstanceCopyData {
  [key: string]: unknown;
}

interface BackupData {
  instanceId: string;
  id?: string;
  [key: string]: unknown;
}

interface OverwriteData {
  sourceInstanceId: string;
  [key: string]: unknown;
}

export const getCurrentUser = async () => {
  // Phase 3: Call local endpoint (was Studio /api/user/loggedinUser)
  return await fetch("/api/v1/admin/users/me", {
    headers: await authService.getAuthorizationHeader(),
  })
    .then(errorHandler)
    .then((response) => response.json());
};

export const getTenants = async () => {
  // Phase 3: Call local endpoint (was Studio /api/tenant/)
  return await fetch("/api/v1/admin/instances/my", {
    headers: await authService.getAuthorizationHeader(),
  })
    .then(errorHandler)
    .then((response) => response.json());
};

export const getInstance = async () => {
  // Phase 3: Call local endpoint (was Studio /api/instance/)
  return await fetch("/api/v1/admin/instances", {
    headers: await authService.getAuthorizationHeader(),
  })
    .then(errorHandler)
    .then((response) => response.json());
};

// SPC-only stubs — these features don't exist in the local SkyAdvisor deployment
export const checkLakehouseCreationStatus = async (_instanceId: string) => {
  return Promise.resolve({ status: "not_applicable" });
};

export const removeInstances = async (_id: string) => {
  return Promise.resolve({ isSuccess: false, message: "Not supported in local deployment" });
};

export const editCreateInstance = async (_data: InstanceFormData) => {
  return Promise.resolve({ isSuccess: false, message: "Not supported in local deployment" });
};

export const copyFromInstance = async (_data: InstanceCopyData) => {
  return Promise.resolve({ isSuccess: false, message: "Not supported in local deployment" });
};

export const clearCDPInstances = async (_id: string, _type: string) => {
  return Promise.resolve({ isSuccess: false, message: "Not supported in local deployment" });
};

export const clearPrivacyInstances = async (_id: string) => {
  return Promise.resolve({ isSuccess: false, message: "Not supported in local deployment" });
};

export const getPubSubServiceUri = async (_hubName: string) => {
  return Promise.resolve({ uri: "" });
};

export const getBackups = async (_data: { id: string }): Promise<any> => {
  return Promise.resolve({ backups: [] });
};

export const createInstancebackup = async (_data: BackupData): Promise<any> => {
  return Promise.resolve({
    isSuccessful: false,
    message: "Not supported in local deployment",
    entity: null,
  });
};

export const removeInstancebackup = async (_data: BackupData): Promise<any> => {
  return Promise.resolve({
    isSuccessful: false,
    message: "Not supported in local deployment",
    entity: null,
  });
};

export const overwriteInstance = async (_data: OverwriteData): Promise<any> => {
  return Promise.resolve({ isSuccessful: false, message: "Not supported in local deployment" });
};

export const getDefaultInstanceById = async (_id: string): Promise<any> => {
  return Promise.resolve({
    instanceDefault: {
      timezone: "",
      language: "",
      dateandNumberFormat: "",
      currency: "",
      domain: "",
    },
  });
};

export const changedInstanceLogCreate = async (_type: string) => {
  // No-op: SPC-only audit log call
  return Promise.resolve({ isSuccess: true });
};
